 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		"app": 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"app": 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "js/" + ({"404":"404","activation":"activation","lenta":"lenta","messages":"messages","dashboard":"dashboard","document":"document","events":"events","notifications":"notifications","places":"places","profile":"profile","remind":"remind","settings":"settings","shop":"shop","users":"users","welcome":"welcome","ya":"ya"}[chunkId]||chunkId) + "." + {"404":"5485d342","activation":"160f06a5","chunk-02af089f":"0703ad39","chunk-4359fa81":"41e60508","chunk-2d0e9741":"924d1c3c","chunk-4db46d17":"64d44bd6","chunk-63462850":"2bf26dc6","chunk-6eb02400":"104e61c6","chunk-71153e5e":"14c11a99","chunk-c58275ca":"defc5d8c","chunk-4622d7af":"934c77ab","lenta":"e41424fe","messages":"576fb30d","chunk-df294a10":"b00cebb9","dashboard":"c9b5caeb","document":"a9f2de9c","events":"ad60a0ab","notifications":"12d44297","places":"0395ba2f","profile":"c07b212a","remind":"dd44f10f","settings":"b7b7bf14","shop":"66dd50c2","users":"d0bc0fbb","welcome":"278d7cfe","ya":"16aafec1","chunk-2d0a4bb8":"85b6be5d","chunk-006fd8c6":"ddd58858","chunk-07015286":"5c9cbe4d","chunk-2d21807b":"15d5da8f","chunk-0a5a7e1a":"aae04b99","chunk-0be79e23":"b30a208c","chunk-30fc375c":"30f10dc9","chunk-4a4965d3":"2d9d01b6","chunk-702a88e8":"20fde02e","chunk-4d2e7b9a":"c7dcc3cd","chunk-842a3968":"c193f4a6","chunk-6c000d70":"8deaaafc","chunk-9734ee5a":"87eb4249","chunk-0d6fce35":"51f93782","chunk-128afb7f":"de0c1f1a","chunk-2a4db098":"57cbb92d","chunk-2d0d79a0":"94ec8115","chunk-57e7331e":"911c08d7","chunk-6a3b75ed":"d1ca8f92","chunk-6f9749ba":"4718aef7","chunk-87c046fe":"f425cfb7","chunk-efe52bda":"f98f88b1","chunk-102b6bf9":"a6b06327","chunk-1b2dcce6":"f51c8513","chunk-2d0abc7a":"94b6923c","chunk-2d0e665a":"27383ce9","chunk-2d21a779":"1a721599","chunk-49ba0055":"619aa6c2","chunk-4a2ff638":"0e25f6a6","chunk-90d1dbfa":"9d9854cf","chunk-febc63c4":"8238f681","chunk-ff530316":"27201468","chunk-2d0dd40c":"9f1fa99e","chunk-2d2140bb":"a68da7e6","chunk-0db2fada":"8c07deef","chunk-24decb7e":"f209c463","chunk-2d0c5224":"c7437684","chunk-2d0cc7d6":"d8c030a6","chunk-45cfc759":"74802da7","chunk-7dc2c720":"d6b48913","chunk-d8252196":"4dffe6c6","chunk-2d225250":"17b5e7a9","chunk-2d22c55b":"f5675c1b","chunk-2d22d429":"f7899717","chunk-33e253a8":"741c9a39","chunk-43516c3a":"2b4fbe1a","chunk-2b907ce7":"7579868f","chunk-31faf048":"ff37b317","chunk-8795a928":"15beb248","chunk-58396013":"0c8fdc89","chunk-5eeac758":"96db50b6","chunk-6a471b10":"23945cd3","chunk-7144285f":"042f665f","chunk-a80364da":"3857c86d","chunk-2b928f16":"f7a2fa57","chunk-37b1cc3c":"b40bc271","chunk-2d0a40a7":"20735502","chunk-f928bb74":"3781009c","chunk-041b0fec":"ba148be2","chunk-2a3e7b1c":"29608030","chunk-2cf3730b":"b8610e53","chunk-2d0c06c4":"1eb17ecd","chunk-2d0deb31":"c0874c52","chunk-38fa6ca8":"7b9a3d15","chunk-3a46014e":"4d06c79d","chunk-52f8a762":"f0706f4c","chunk-44cc07a5":"0a8db450","chunk-54834e78":"e94a8c0a","chunk-f1322c34":"fa6c9916","chunk-22c32762":"e34bf0ad","chunk-92be399a":"f4051e8c","chunk-350c1a22":"4d450bbd","chunk-dd35bebe":"930dc730","chunk-2d0b1e24":"314d9c0a","chunk-2d224ca0":"fa9d74ba","chunk-fc27ad9c":"ac8d62c6","chunk-5234a8be":"42463af8","chunk-2d0d3aef":"c8d7ed06","chunk-2d0efc8e":"cae6e346","chunk-41b52670":"ee3b2d38","chunk-b3e76180":"e9f92a7a","chunk-ec6a12f8":"3cbabb54","chunk-6840bb89":"77a14f04","chunk-18f88804":"0a85fa44","chunk-d0c89db2":"30a5a7b0","chunk-eb9eccf2":"8f75ac09","chunk-d7741d48":"b549a1aa","chunk-2d0b1a52":"af038a9a","chunk-1ca4a59e":"b3a3a700","chunk-2d0b6aa9":"503fc3e1","chunk-2d2227c5":"0f58289d","chunk-7915c2c1":"0c3cd66c","chunk-542c5e73":"d0fa6e96","chunk-79a32d72":"862e7528","chunk-2d0d780a":"e13aa5ab"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"404":1,"chunk-4db46d17":1,"chunk-63462850":1,"chunk-6eb02400":1,"chunk-71153e5e":1,"chunk-4622d7af":1,"lenta":1,"messages":1,"dashboard":1,"document":1,"events":1,"places":1,"remind":1,"settings":1,"shop":1,"welcome":1,"chunk-0be79e23":1,"chunk-702a88e8":1,"chunk-6c000d70":1,"chunk-9734ee5a":1,"chunk-0d6fce35":1,"chunk-128afb7f":1,"chunk-57e7331e":1,"chunk-6a3b75ed":1,"chunk-6f9749ba":1,"chunk-87c046fe":1,"chunk-efe52bda":1,"chunk-102b6bf9":1,"chunk-49ba0055":1,"chunk-90d1dbfa":1,"chunk-febc63c4":1,"chunk-0db2fada":1,"chunk-45cfc759":1,"chunk-7dc2c720":1,"chunk-d8252196":1,"chunk-33e253a8":1,"chunk-43516c3a":1,"chunk-2b907ce7":1,"chunk-31faf048":1,"chunk-8795a928":1,"chunk-5eeac758":1,"chunk-6a471b10":1,"chunk-7144285f":1,"chunk-a80364da":1,"chunk-2b928f16":1,"chunk-041b0fec":1,"chunk-2cf3730b":1,"chunk-3a46014e":1,"chunk-52f8a762":1,"chunk-44cc07a5":1,"chunk-54834e78":1,"chunk-f1322c34":1,"chunk-22c32762":1,"chunk-92be399a":1,"chunk-350c1a22":1,"chunk-dd35bebe":1,"chunk-5234a8be":1,"chunk-41b52670":1,"chunk-b3e76180":1,"chunk-ec6a12f8":1,"chunk-6840bb89":1,"chunk-18f88804":1,"chunk-d0c89db2":1,"chunk-eb9eccf2":1,"chunk-d7741d48":1,"chunk-1ca4a59e":1,"chunk-542c5e73":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "css/" + ({"404":"404","activation":"activation","lenta":"lenta","messages":"messages","dashboard":"dashboard","document":"document","events":"events","notifications":"notifications","places":"places","profile":"profile","remind":"remind","settings":"settings","shop":"shop","users":"users","welcome":"welcome","ya":"ya"}[chunkId]||chunkId) + "." + {"404":"562c3491","activation":"31d6cfe0","chunk-02af089f":"31d6cfe0","chunk-4359fa81":"31d6cfe0","chunk-2d0e9741":"31d6cfe0","chunk-4db46d17":"54799f76","chunk-63462850":"54799f76","chunk-6eb02400":"54799f76","chunk-71153e5e":"8d3348fa","chunk-c58275ca":"31d6cfe0","chunk-4622d7af":"9ed28efb","lenta":"141e482a","messages":"19c3d81d","chunk-df294a10":"31d6cfe0","dashboard":"9bb1caf6","document":"d4317369","events":"eabe7d56","notifications":"31d6cfe0","places":"b8e37730","profile":"31d6cfe0","remind":"889e5232","settings":"26d5a09f","shop":"ccd9c67f","users":"31d6cfe0","welcome":"4ba57b92","ya":"31d6cfe0","chunk-2d0a4bb8":"31d6cfe0","chunk-006fd8c6":"31d6cfe0","chunk-07015286":"31d6cfe0","chunk-2d21807b":"31d6cfe0","chunk-0a5a7e1a":"31d6cfe0","chunk-0be79e23":"54799f76","chunk-30fc375c":"31d6cfe0","chunk-4a4965d3":"31d6cfe0","chunk-702a88e8":"9c56c74a","chunk-4d2e7b9a":"31d6cfe0","chunk-842a3968":"31d6cfe0","chunk-6c000d70":"48342a86","chunk-9734ee5a":"82999f61","chunk-0d6fce35":"8db14848","chunk-128afb7f":"cb50d2b9","chunk-2a4db098":"31d6cfe0","chunk-2d0d79a0":"31d6cfe0","chunk-57e7331e":"c56ee617","chunk-6a3b75ed":"0f2e1d9d","chunk-6f9749ba":"12911af4","chunk-87c046fe":"37ee05be","chunk-efe52bda":"53bb60eb","chunk-102b6bf9":"7bc70154","chunk-1b2dcce6":"31d6cfe0","chunk-2d0abc7a":"31d6cfe0","chunk-2d0e665a":"31d6cfe0","chunk-2d21a779":"31d6cfe0","chunk-49ba0055":"447e641c","chunk-4a2ff638":"31d6cfe0","chunk-90d1dbfa":"246e1d65","chunk-febc63c4":"b5c55209","chunk-ff530316":"31d6cfe0","chunk-2d0dd40c":"31d6cfe0","chunk-2d2140bb":"31d6cfe0","chunk-0db2fada":"c2167bb5","chunk-24decb7e":"31d6cfe0","chunk-2d0c5224":"31d6cfe0","chunk-2d0cc7d6":"31d6cfe0","chunk-45cfc759":"c217a68c","chunk-7dc2c720":"c217a68c","chunk-d8252196":"c217a68c","chunk-2d225250":"31d6cfe0","chunk-2d22c55b":"31d6cfe0","chunk-2d22d429":"31d6cfe0","chunk-33e253a8":"7149ca96","chunk-43516c3a":"96a655cf","chunk-2b907ce7":"7cf7d179","chunk-31faf048":"d4dd2027","chunk-8795a928":"16b65d22","chunk-58396013":"31d6cfe0","chunk-5eeac758":"aaa6b239","chunk-6a471b10":"9990d306","chunk-7144285f":"ade18b73","chunk-a80364da":"afe3a07b","chunk-2b928f16":"906fbd94","chunk-37b1cc3c":"31d6cfe0","chunk-2d0a40a7":"31d6cfe0","chunk-f928bb74":"31d6cfe0","chunk-041b0fec":"fbe2a1b1","chunk-2a3e7b1c":"31d6cfe0","chunk-2cf3730b":"c217a68c","chunk-2d0c06c4":"31d6cfe0","chunk-2d0deb31":"31d6cfe0","chunk-38fa6ca8":"31d6cfe0","chunk-3a46014e":"90d9e5f3","chunk-52f8a762":"c79e4f52","chunk-44cc07a5":"c217a68c","chunk-54834e78":"87ec2c3a","chunk-f1322c34":"c217a68c","chunk-22c32762":"bb775ea7","chunk-92be399a":"ef659b92","chunk-350c1a22":"b08cfa14","chunk-dd35bebe":"0686d0e2","chunk-2d0b1e24":"31d6cfe0","chunk-2d224ca0":"31d6cfe0","chunk-fc27ad9c":"31d6cfe0","chunk-5234a8be":"7149ca96","chunk-2d0d3aef":"31d6cfe0","chunk-2d0efc8e":"31d6cfe0","chunk-41b52670":"4357a3a4","chunk-b3e76180":"7f55a3fb","chunk-ec6a12f8":"8158295a","chunk-6840bb89":"6b448161","chunk-18f88804":"f19d55f8","chunk-d0c89db2":"c41a1a60","chunk-eb9eccf2":"62b78afd","chunk-d7741d48":"5c621812","chunk-2d0b1a52":"31d6cfe0","chunk-1ca4a59e":"5351f32f","chunk-2d0b6aa9":"31d6cfe0","chunk-2d2227c5":"31d6cfe0","chunk-7915c2c1":"31d6cfe0","chunk-542c5e73":"15f13a14","chunk-79a32d72":"31d6cfe0","chunk-2d0d780a":"31d6cfe0"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// add entry module to deferred list
 	deferredModules.push([0,"chunk-vendors"]);
 	// run deferred modules when ready
 	return checkDeferredModules();
